export default __webpack_public_path__ + "static/media/merrco-logo.8f79511f.svg";